<template>
    <div class="page-title">
        <h2 class="h2">
            <slide-x-left-transition :duration="700">
                <svg v-show="show && back && !routeName" @click="goBack" class="icon icon-chevron-back">
                    <use xlink:href="#icon-chevron-back"></use>
                </svg>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="700">
                <svg v-show="show && back && routeName" @click="goTo(routeName, routeParam)" class="icon icon-chevron-back">
                    <use xlink:href="#icon-chevron-back"></use>
                </svg>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="200">
                <span v-show="show" :class="{ 'has-margin': back }">{{ title }}</span>
            </slide-x-left-transition>
        </h2>
    </div>
</template>

<script>
    import goTo from '@/mixins/goto';

    export default {
        name: 'PageTitle',
        props: ['title', 'back', 'routeName', 'routeParam'],
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted(){
          this.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    span{
        display: inline-block;
    }
    .has-margin{
        margin-left: 22px;
    }
</style>